import { FC } from 'react';
import AcceptMinkaAllDeliver from './AcceptMinkaAllDeliver';
import UseAcceptMinkaAllDeliver from './UseAcceptMinkaAllDeliver';

const AcceptMinkaAllDeliverContainer: FC = () => {
  return <AcceptMinkaAllDeliver {...UseAcceptMinkaAllDeliver()} />;
};

export default AcceptMinkaAllDeliverContainer;
